import { useTranslation } from 'react-i18next'

import { SpinningCircle } from '@/components/icons/SpinningCircle'

export const ProcessingPrescription = () => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center gap-6 p-8">
      <h1 className="text-primary text-center text-2xl font-bold">{t('delivery.address.processing')}</h1>
      <SpinningCircle />
      <p>{t('download.one_minute')}</p>
    </div>
  )
}
